Bacon = require 'baconjs'
R = require 'ramda'
Dispatcher = require 'utils/dispatcher'

{ loadResourceFromUrl, findResourceLink } = require "utils/resources"
{ createResource, updateResource } = require "utils/resources"

restaurantStore = require "stores/restaurant"

# TODO: Use Settings for feedback svc
FEEDBACK_SVC = window.page_config.FEEDBACK_SVC

currentOrder = new Bacon.Bus
currentOrderProperty = currentOrder.toProperty()
closeSessionRequest = new Bacon.Bus
reloadOrderBus = new Bacon.Bus

d = new Dispatcher('feedbacks')

favoritesStream = d.stream('toggle-favorite')

selectSubjects = (subjects, type) ->
  subjects.map R.filter R.pipe(R.prop('type'), R.equals(type))

loadOrderUrl = currentOrder
  .map (uuid) -> "/v4/orders/#{uuid}.json"

reloadOrderUrl = loadOrderUrl
  .sampledBy reloadOrderBus


loadResourceFromUrlWithRetries = (url) ->
  Bacon.retry
    source: -> loadResourceFromUrl url
    retries: 5
    isRetryable: (error) ->
      error.status != 500
    delay: ({error, retriesDone}) ->
      retriesDone * 500

createResourceWithRetries = (params) ->
  Bacon.retry
    source: -> createResource params
    retries: 2
    isRetryable: (error) ->
      error.status != 500
    delay: ({error, retriesDone}) ->
      retriesDone * 500

loadOrderStream = Bacon.mergeAll loadOrderUrl, reloadOrderUrl
  .flatMap loadResourceFromUrlWithRetries
  .map R.prop('order')
  .toProperty()

loadOrderStreamError = loadOrderStream
  .errors()
  .flatMapError (data) ->
    if data.message
      new Bacon.Next data.message
    else
      new Bacon.Next "#{R.path(['status', 'code'], data)} - #{R.path(['status', 'message'], data)}"

restaurantStore.connect loadOrderStream.map(R.path ['restaurant', 'resource_url'])

reloadOrder = loadOrderStream
  .sampledBy reloadOrderBus

toggleFavorite = favoritesStream
  .flatMap ({ order, favorite }) ->
    updateResource
      url: findResourceLink 'self', 'put', order
      order: { favorite }
    .map (response) ->
      R.merge order, response.order

orderStream = Bacon.mergeAll loadOrderStream, reloadOrder, toggleFavorite

orderStateUrl = loadOrderStream
  .map (order) -> order.id
  .map (uuid) -> "/v4/orders/#{uuid}/state.json"
  

pageIsActive = true
pageActivated = new Bacon.Bus()
pageActivations = pageActivated
  .debounceImmediate(30*1000)
  .flatMap -> orderStateUrl

handleVisibilityChange = (ev) ->
  pageIsActive = document.visibilityState isnt "hidden"
  if pageIsActive
    pageActivated.push(new Date)

try
  document.addEventListener('visibilitychange', handleVisibilityChange, false)
catch ex
  pageIsActive = true


orderStateUrlPolling = orderStateUrl
  .sampledBy Bacon.interval 30*1000
  .skipWhile () -> !pageIsActive

orderState = Bacon.mergeAll orderStateUrl, orderStateUrlPolling,  pageActivations
  .flatMap loadResourceFromUrlWithRetries
  .map R.path ['order', 'state']
  .mapError R.always 'executing'
  .toProperty()
  .skipDuplicates()

# Reload order when state changes (time). Skip on first load
reloadOrderBus.plug orderState.skip(1)

createSessionStream = loadOrderStream
  .take 1
  .map R.prop('id')
  .map R.assoc 'uuid', R.__, url: "#{FEEDBACK_SVC}/sessions/import-order.json"
  .flatMap createResourceWithRetries

closeSessionStream = closeSessionRequest
  .combine createSessionStream, (ts, session) -> "#{FEEDBACK_SVC}/sessions/#{session.session.id}/closeSession.json"
  .map R.assoc 'url', R.__, {}
  .flatMap createResourceWithRetries

notifyError = (data) ->
  window.Bugsnag and Bugsnag.notify and Bugsnag.notify("Feedback Service", JSON.stringify(data))

feedbackSession = Bacon
  .mergeAll [ createSessionStream, closeSessionStream ]
  .map R.prop('session')
  .doError notifyError
  .toProperty()

feedbackSessionError = feedbackSession
  .errors()
  .flatMapError (data) ->
    if data.message
      new Bacon.Error "Feedback service error. Info: #{data.message}"
    else
      new Bacon.Error "Feedback service error. Info: #{R.path(['status', 'code'], data)} - #{R.path(['status', 'message'], data)}"

feedbackSubjects = feedbackSession
  .map R.prop 'subjects'
  .toProperty()

#------ RATINGS
newRatings = new Bacon.Bus

getRatings = feedbackSession
  .map findResourceLink('ratings', "get")
  .flatMap loadResourceFromUrlWithRetries
  .map R.prop 'ratings'
  .toEventStream()

saveRatingStream = newRatings
  .flatMap ({subject, score, comment}) ->
    url = findResourceLink('ratings', "post")(subject)
    createResourceWithRetries url: url, score: score, comment: comment
  .map R.prop('rating')
  .toEventStream()

ratings = Bacon.update [],
  [getRatings], (prev, ratings) -> ratings
  [saveRatingStream], ( prev, rating ) ->
    index = R.findIndex R.pipe(R.prop('id'), R.equals(rating.id)), prev
    if index >= 0
      prev = R.update index, rating, prev
    else
      prev = R.append rating, prev
    R.filter R.pipe(R.prop('_removed'), R.defaultTo(false), R.equals(false)), prev

subjectIdReductor = (s, r) -> R.assoc r.subject_id, r, s
lookupRatingsBySubjectId = ratings.map R.reduce(subjectIdReductor, {})

feedbackSubjectsAndRatings = feedbackSubjects
  .combine lookupRatingsBySubjectId, (subjects, ratings) ->
    subjects.map (subject) ->
      R.assoc 'rating', ratings[subject.id], subject

filterQuestionsByLocale =
  (subjects, locale) -> R.filter R.propEq('locale', locale), subjects

feedbackItemSubjects = selectSubjects(feedbackSubjectsAndRatings, 'item')
feedbackQuestionSubjects = selectSubjects(feedbackSubjectsAndRatings, 'question')
  .combine restaurantStore.localeId, filterQuestionsByLocale
feedbackReviewSubjects = selectSubjects(feedbackSubjectsAndRatings, 'review')

module.exports =
  openOrder: (uuid) -> currentOrder.push uuid
  closeSession: -> closeSessionRequest.push new Date
  order: orderStream
  orderError: loadOrderStreamError
  state: orderState
  feedbackSession: feedbackSession.toProperty()
  feedbackErrors: feedbackSessionError
  feedbackItemSubjects: feedbackItemSubjects.toProperty()
  feedbackQuestionSubjects: feedbackQuestionSubjects.toProperty()
  feedbackReviewSubjects: feedbackReviewSubjects.toProperty()
  rate: (subject, score, comment) ->
    newRatings.push subject: subject, score: score, comment: comment
  ratings: ratings
  toggleFavorite: (order, favorite) ->
    favoritesStream.push order: order, favorite: favorite
